<template>
  <validation-observer
    v-if="shouldQuestionRender && isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="relationship-proposer"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <!-- RELATIONSHIP PROPOSER GENERIC -->
      <form-row label="What is their relationship to you?">
        <validation-provider
          v-slot="{ failed, failedRules, errors }"
          :vid="`${stepId}_relationship-proposer`"
          name="Relationship Proposer Status"
          :rules="{ is_not: { other: null } }"
        >
          <radio
            v-model="relationshipProposerGenericModel"
            :name="`${stepId}.relationship-proposer`"
            :data-test="fieldTrackerId.main"
            :items="relationshipProposerGenericOptions"
            :error="failed"
            :error-messages="getFieldErrors('relationshipProposer', failedRules, errors)"
            column
            return-object
          />
        </validation-provider>
      </form-row>
      <!-- RELATIONSHIP PROPOSER OTHER -->
      <form-row
        v-if="relationshipProposerGenericModel !== null && !constants.ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES.includes(relationshipProposerGenericModel)"
        gap="16"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_relationship-proposer`"
          name="Relationship Proposer Status (Other)"
          rules="listOptionRequired"
        >
          <qz-select
            v-model="questionData.relationshipProposer"
            :data-test="fieldTrackerId.other"
            :items="relationshipProposerOtherOptions"
            :error-messages="errors"
            :placeholder="helpers.getPlaceholderResponsiveText((optionsConfig && optionsConfig.otherPlaceholder) || 'Please select appropriate relationship', isMobile)"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import {
  omit,
  pick,
  snakeCase,
} from 'lodash';
import QuestionBase from './Base';

export default {
  name: 'question-relationship-proposer',
  extends: QuestionBase,
  data () {
    return {
      fields: ['relationshipProposer'],
    };
  },
  computed: {
    relationshipProposerGenericModel: {
      get () {
        if (this.questionData.relationshipProposer === null) return null;
        return this.constants.ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES.includes(this.questionData.relationshipProposer) ? this.questionData.relationshipProposer : true;
      },
      set (val) {
        this.questionData.relationshipProposer = val.logical ? val.logicalValue : val.value;
      },
    },
    relationshipProposerGeneric () {
      return [
        ...this.helpers.createOptions({ source: pick(this.constants.ADDITIONAL_RELATIONSHIP_PROPOSER, this.constants.ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES) }),
        this.constants.OTHER_OPTIONS,
      ];
    },
    relationshipProposerOther () {
      return this.helpers.createOptions({ source: omit(this.constants.ADDITIONAL_RELATIONSHIP_PROPOSER, this.constants.ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES) });
    },
    relationshipProposerGenericOptions () {
      return this.relationshipProposerGeneric.filter(({ value }) => this.validateRelationshipItem(value));
    },
    relationshipProposerOtherOptions () {
      return this.relationshipProposerOther.filter(({ value }) => this.validateRelationshipItem(value));
    },
    mainInsurer () {
      // TODO add conditions for other products
      return this.formData.drivers[0];
    },
    otherAdditionalInsurers () {
      // TODO add conditions for other products
      return this.formData.drivers.filter((driver, index) => ![0, this.stepIndex].includes(index));
    },
    fieldTrackerId () {
      return {
        main: snakeCase(this.questionFields.relationshipProposer),
        other: `${snakeCase(this.questionFields.relationshipProposer)}_other`,
      };
    },
  },
  created () {
    if (this.isAdditional && this.stepData.relationshipProposer) {
      if (!this.validateRelationshipItem(this.stepData.relationshipProposer)) this.questionData.relationshipProposer = null;
    }
  },
  watch: {
    relationshipProposerGenericOptions () {
      if (!this.validateRelationshipItem(this.questionData.relationshipProposer)) {
        this.questionData.relationshipProposer = null;
      }
    },
  },
  methods: {
    validateRelationshipItem (value) {
      // Can't be Spouse or Civil Partner if main driver is not married and not in civil partnership
      if (['S', 'V'].includes(value) && !['M', 'V'].includes(this.mainInsurer.maritalStatus)) {
        return false;
      }

      // Can't be Common Law Spouse if main main driver is not Common Law
      if ((!['C'].includes(this.mainInsurer.maritalStatus) || !['C'].includes(this.stepData.maritalStatus)) && ['C'].includes(value)) {
        return false;
      }

      // Has already Spouse as another additional driver
      if (value === 'S' && this.otherAdditionalInsurers.some(({ relationshipProposer }) => relationshipProposer === 'S')) {
        return false;
      }

      // Has already Civil partner as another additional driver
      if (value === 'V' && this.otherAdditionalInsurers.some(({ relationshipProposer }) => relationshipProposer === 'V')) {
        return false;
      }

      // Can't be Spouse or Civil Partner if is not married or not in civil partnership
      if (['S', 'V'].includes(value) && !['M', 'V'].includes(this.stepData.maritalStatus)) {
        return false;
      }

      return true;
    },
  },
};
</script>
